function addParams(url, query, isClassical = false) {
    const campaign = isClassical ? 'classical' : 'autoredirect';
    const [base, search] = url.split('?');
    const searchParams = search ? new URLSearchParams(search) : new URLSearchParams();
    searchParams.set('int_source', 'search');
    searchParams.set('int_medium', 'search');
    searchParams.set('int_term', query);
    searchParams.set('int_campaign', campaign);
    searchParams.set('int_content', window?.location?.pathname);
    return `${base}?${searchParams.toString()}`;
}

export { addParams };
//# sourceMappingURL=addParams.js.map
